/* eslint-disable @typescript-eslint/no-explicit-any */
import Script from 'next/script';
import { useEffect, useState } from 'react';
import { SvgIcon } from 'helpers/SvgIcon';
import { SiteStructure } from '.generated/Feature.CW.model';

// Types
export type SocialMediaProps = SiteStructure.Footer.SocialMedia_Component & {
  fields: {
    socialMediaLinks: Array<SiteStructure.Footer.SocialMediaItem_Item>;
  };
};

const SocialShare = (props: SocialMediaProps): JSX.Element => {
  const [isClient, setClient] = useState(false);
  const socialMediaList = props?.fields?.socialMediaLinks;

  useEffect(() => {
    setClient(true);
  }, []);

  useEffect(() => {
    if (isClient && (window as any).a2a) {
      (window as any).a2a.init_all();
    }
  }, [isClient]);

  if (!isClient) return <></>;

  return (
    <>
      <Script
        src="https://static.addtoany.com/menu/page.js"
        strategy="afterInteractive"
        onLoad={() => {
          if ((window as any).a2a) {
            (window as any).a2a.init_all();
          }
        }}
      />
      <div className="max-w-screen-xxl mx-auto">
        <div className="pb-4 text-14 leading-22 font-bold font-nunito" id="share-heading">
          Share to:
        </div>
        <div
          className="a2a_kit a2a_kit_size_32 a2a_default_style flex"
          role="group"
          aria-labelledby="share-heading"
        >
          {socialMediaList?.map((socialMediaItem: any, index: number) => {
            return (
              <a
                aria-label={`Share to ${socialMediaItem?.fields?.title?.value}`}
                key={index}
                className={`a2a_button_${socialMediaItem?.fields?.title?.value.toLowerCase()}`}
              >
                <div className="p-6 bg-blue-100 rounded-full mr-4 text-blue-700 hover:bg-blue-700 hover:text-white">
                  <SvgIcon
                    icon={socialMediaItem?.fields?.title?.value.toLowerCase()}
                    size="lg"
                    className="object-contain object-center"
                  />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SocialShare;
